/**
 * 学习乐园 · 连连看题材包：分数小数百分数（lianliankan/pack-fenshu.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：分数连小数连百分数（「1/2」连「0.5」）。同一个数只以两种
 * 形式出现在一对里——三个表示法凑成三角会出现重复牌面（0.5 既连 1/2 又
 * 连 50%），而本页口径是 rel 型跨对牌面必须唯一（配错反馈才指得准），
 * 所以每个值只出一对，26 对覆盖 halves/quarters/fifths/eighths/tenths/
 * twentieths/25 分母/整百倍数等常用互化。循环小数（1/3≈0.33…）不收——
 * 不等值就不算配对。池大于 6×6 盘（18 对），引擎每局随机抽 18 对上桌。
 * note 直接给换算要点，配错反馈里就是那句话。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.fenshu = {
    id: 'fenshu',
    name: '分数小数百分数',
    hint: '同一个数，换个写法也认识它',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '1/2', r: '0.5', note: '一半就是 0.5，也是 50%' },
      { l: '25%', r: '1/4', note: '四分之一就是 25%' },
      { l: '0.75', r: '75%', note: '四分之三就是 75%' },
      { l: '1/5', r: '0.2', note: '五分之一就是 0.2' },
      { l: '40%', r: '2/5', note: '五分之二就是 40%' },
      { l: '0.6', r: '3/5', note: '五分之三就是 0.6' },
      { l: '4/5', r: '80%', note: '五分之四就是 80%' },
      { l: '0.1', r: '10%', note: '十分之一就是 10%' },
      { l: '1/8', r: '0.125', note: '八分之一就是 0.125' },
      { l: '37.5%', r: '3/8', note: '八分之三就是 37.5%' },
      { l: '0.625', r: '5/8', note: '八分之五就是 0.625' },
      { l: '7/8', r: '87.5%', note: '八分之七就是 87.5%' },
      { l: '5%', r: '1/20', note: '二十分之一就是 5%' },
      { l: '0.04', r: '1/25', note: '二十五分之一就是 0.04' },
      { l: '0.3', r: '3/10', note: '十分之三就是 0.3' },
      { l: '70%', r: '7/10', note: '十分之七就是 70%' },
      { l: '0.9', r: '9/10', note: '十分之九就是 0.9' },
      { l: '150%', r: '3/2', note: '百分数超过 100%，对应的数就大于 1' },
      { l: '0.35', r: '7/20', note: '百分之三十五约分' },
      { l: '45%', r: '9/20', note: '百分之四十五约分' },
      { l: '16%', r: '4/25', note: '百分之十六约分' },
      { l: '0.44', r: '11/25', note: '百分之四十四约分' },
      { l: '68%', r: '17/25', note: '百分之六十八约分' },
      { l: '0.92', r: '23/25', note: '百分之九十二约分' },
      { l: '0.08', r: '2/25', note: '百分之八约分' },
      { l: '300%', r: '3', note: '300% 就是 3，百分数也能超过一' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
